import { memo } from "react";
import { cn } from "@/ui/kit/cn";
import { A } from "./tok";
import { v } from "./vars";

/** Cursor Agent has no theme setting: everything here is a terminal ANSI color. */
export const CursorAgentPreview = memo(function CursorAgentPreview({
  compact = false,
}: {
  compact?: boolean;
}) {
  return (
    <div
      className={cn(
        "space-y-[0.55lh] p-3",
        compact ? "text-[11px] leading-[1.45]" : "text-[13px] leading-[1.55]",
      )}
    >
      <div className="whitespace-pre">
        <A i={6} bold>
          Cursor Agent
        </A>{" "}
        <A i={8}>· auto · ~/ghq/github.com/lnutimura/themes</A>
      </div>
      <div
        className="whitespace-pre rounded-md border px-[1ch]"
        style={{ borderColor: v("terminal.ansi8") }}
        data-token="terminal.ansi8"
      >
        <A i={7}>refactor the exporter registry to a typed list</A>
      </div>
      <div className="whitespace-pre">
        <A i={4}>⬢</A> Read <A i={8}>src/exporters/registry.ts</A>
      </div>
      <div className="whitespace-pre">
        <A i={4}>⬢</A> Edit <A i={8}>registry.ts</A> <A i={2}>+3</A> <A i={1}>-2</A>
        <br />
        {"   "}
        <A i={1}>- export const EXPORTERS = [</A>
        <br />
        {"   "}
        <A i={2}>+ export const EXPORTERS: Exporter[] = [</A>
      </div>
      <div className="whitespace-pre">
        <A i={3}>$</A> pnpm test <A i={2}>✓ passed</A> <A i={8}>(3.9s)</A>
      </div>
      {!compact && (
        <div className="whitespace-pre">
          <A i={5}>◆</A> Summary:{" "}
          <A i={15} bold>
            EXPORTERS
          </A>{" "}
          is now typed; nothing else changed.
        </div>
      )}
      <div
        className="whitespace-pre rounded-md border px-[1ch]"
        style={{ borderColor: v("terminal.ansi8") }}
      >
        <A i={8}>→ Add a follow-up</A>
      </div>
      <div className="whitespace-pre">
        <A i={8}>auto-run off · 42% context · ctrl+c to stop</A>
      </div>
    </div>
  );
});
